var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',{staticClass:"text-center"},[_c('h2',[_vm._v("Login")]),_c('b-button',{attrs:{"to":{name: 'login_router'}}},[_vm._v("Login")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }